<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
    <div class="header-row">
        <i class="fas fa-database"></i>
        <span>Upload Master - Select master name, upload Excel, or download sample file</span>
    </div>

    <div class="main-row">
        <!-- Master Selection -->
        <div class="control-group" style="width: 270px;">
            <span class="control-label">
                <i class="bi bi-list-ul"></i> Master:
            </span>
            <ng-select [appendTo]="'body'" name="branch" [items]="Masters" bindLabel="ExcelUploadName"
                bindValue="ESS_ExcelUploadMasterID" [(ngModel)]="this.Filter.ESS_ExcelUploadMasterId"
                placeholder="Select Master" (change)="setallowsubmit()" style="width: -webkit-fill-available;">
            </ng-select>
        </div>

        <!-- File Upload -->
        <div class="control-group">
            <span class="control-label">
                <i class="bi bi-file-earmark-arrow-up-fill"></i> Upload:
            </span>
            <div class="file-upload-wrapper" *ngIf="this.uploadfile == null">
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInputChange($event)"
                    accept=".xlsx,.xls,.csv">
                <label type="button" role="button" class="upload-btn" id="browseBtn" for="file-upload">
                    <i class="bi bi-folder2-open"></i>
                    Browse
                </label>
                <div class="formats">
                    <span class="format-tag">.xlsx</span>
                    <span class="format-tag">.xls</span>
                    <span class="format-tag">.csv</span>
                </div>
            </div>
            <div id="fileStatus" class="file-status" *ngIf="this.uploadfile != null">
                <i class="fas fa-check-circle"></i>
                <span id="fileName">{{this.uploadfile.name}}</span>
                <button class="remove-btn" id="removeFile" (click)="removeFile()">
                    <i class="bi bi-x-circle-fill"></i>
                </button>
            </div>
        </div>

        <!-- Sample Download -->
        <div class="control-group">
            <span class="control-label">
                <i class="bi bi-file-arrow-down-fill"></i> Sample:
            </span>
            <button type="button" class="sample-btn" id="downloadSampleBtn" (click)="downloadExcel()">
                <i class="bi bi-file-earmark-excel-fill"></i> Download
            </button>
        </div>

        <!-- Upload Action -->
        <button type="button" class="action-btn" id="uploadBtn" (click)="uploadfileData()"
            [disabled]="this.uploadfile == null">
            <i class="bi bi-upload"></i> Upload
        </button>
    </div>
</div>

<div class="dashboard">
    <!-- <div class="dashboard-header">
        <div class="row" style="width: 100%;">
            <div class="col">
                <h5><i class="bi bi-file-earmark-excel-fill"></i>Excel Data Upload</h5>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-success" id="uploadBtn" [routerLink]="['/uploadmaster/add']">
                    <i class="bi bi-upload"></i> Upload
                </button>
            </div>
        </div>
    </div> -->

    <div class="dashboard-stats">
        <div class="stat-card">
            <div class="stat-value">{{this.Card.Total}}</div>
            <div class="stat-label">Total Records</div>
        </div>
        <div class="stat-card">
            <div class="stat-value">{{this.Card.Uploaded}}</div>
            <div class="stat-label">Uploaded Files</div>
        </div>
        <div class="stat-card">
            <div class="stat-value">{{this.Card.Success}}</div>
            <div class="stat-label">Success Files</div>
        </div>
        <div class="stat-card">
            <div class="stat-value">{{this.Card.Fail}}</div>
            <div class="stat-label">Fail Files</div>
        </div>
    </div>

    <div class="recent-uploads">
        <h2><i class="bi bi-arrow-clockwise"></i> Recent Uploads</h2>
        <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th style="width: 100px;">Master</th>
                    <th style="width: 100px;">Batch</th>
                    <th style="width: 100px;">Upload Date</th>
                    <th style="width: 50px;">Data Status</th>
                    <th style="width: 50px;">File Status</th>
                    <th style="width: 50px;">File</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of TableData; let i = index">
                    <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                    <td style="width: 100px;">{{element['ExcelUploadName']}}</td>
                    <td style="width: 100px;">{{element['BatchNo']}}</td>
                    <td style="width: 100px;">{{element['UploadDate']}}</td>
                    <td style="width: 50px;text-align-last:center"><span class="status-badge"
                            [ngClass]="{'status-success': (this.common.ToLowerCase(element['DataStatus']) == 'success' || this.common.ToLowerCase(element['DataStatus']) == 'partial success'),'status-pending': this.common.ToLowerCase(element['DataStatus']) == 'fail','status-upload': (this.common.ToLowerCase(element['DataStatus']) == 'pending')}">
                            {{element['DataStatus']}}</span></td>
                    <td style="width: 50px;text-align-last:center"><span class="status-badge" [ngClass]="{'status-success': this.common.ToLowerCase(element['FileStatus']) ==
                            'success','status-pending': this.common.ToLowerCase(element['FileStatus']) ==
                            'fail','status-upload': (this.common.ToLowerCase(element['FileStatus']) == 'initiated' ||
                            this.common.ToLowerCase(element['FileStatus']) == 'uploaded')}">
                            {{element['FileStatus']}}</span></td>
                    <td style="width: 50px;text-align-last:center"><a [href]="element['UploadFileName']" role="button"
                            class="btn btn-sm btn-primary">
                            <i class="bi bi-download"></i> File
                        </a></td>
                </tr>
            </tbody>
        </table>

    </div>
</div>